import { SET_TASKUPDATINGS, SET_TASKUPDATINGS_UPDATED } from '../constants/TaskUpdatingConstants';

const initialState = {
  taskupdatings: {
    list: [],
    count: 0,
  },
  updated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TASKUPDATINGS: {
      return {
        ...state,
        taskupdatings: {
          list: action.payload.list,
          count: action.payload.count,
        },
        updated: false,
      };
    }

    case SET_TASKUPDATINGS_UPDATED: {
      return {
        ...state,
        updated: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
